function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Defs, Rect, G, Mask, Use, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(Rect, {
  id: "icon-ftp_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  rx: 10
}));

var _ref2 = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Mask, {
  id: "icon-ftp_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement(Use, {
  xlinkHref: "#icon-ftp_svg__a"
})), /*#__PURE__*/React.createElement(Use, {
  fill: "#00245A",
  xlinkHref: "#icon-ftp_svg__a"
}), /*#__PURE__*/React.createElement(G, {
  mask: "url(#icon-ftp_svg__b)"
}, /*#__PURE__*/React.createElement(Path, {
  stroke: "#17BF88",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M26.822 29.007H12.928a3.06 3.06 0 01-3.06-3.06v-.003a3.06 3.06 0 013.06-3.06h13.894a3.06 3.06 0 013.06 3.06v.003a3.06 3.06 0 01-3.06 3.06z"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#17BF88",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M10.422 24.189l2.966-9.973a3.279 3.279 0 013.144-2.347h6.684c1.453 0 2.732.955 3.147 2.347l2.964 9.973"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#17BF88",
  d: "M26.704 25.946a.55.55 0 100 .001"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#FFF",
  d: "M13.046 25.946h1.982"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#17BF88",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75,
  d: "M13.046 25.946h1.982"
}), /*#__PURE__*/React.createElement(G, null, /*#__PURE__*/React.createElement(Path, {
  fill: "#FFF",
  d: "M16.345 25.946h.495"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#17BF88",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75,
  d: "M16.345 25.946h.495"
}))));

function SvgIconFtp(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40
  }, props), _ref, _ref2);
}

export default SvgIconFtp;